import React, { useState } from "react";
import CustomModal from "../modal/CustomModal";
import AlertError from "../ui/error/AlertError";
import AlertSuccess from "../ui/error/AlertSuccess";

const ContactUsButton = () => {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userContactNumber, setUserContactNumber] = useState("");

  const openHandler = () => {
    setOpen(true);
  };

  const closeHandler = () => {
    setOpen(false);
    setIsSuccess(false);
    setError("");
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    setIsSuccess(false);

    try {
      const response = await fetch(
        "https://mosquedonation.azurewebsites.net/api/send-email",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_email: userEmail,
            user_contact_number: userContactNumber,
          }),
        }
      );

      const result = await response.json();
      if (response.ok) {
        setIsSuccess(true);
        setUserEmail("");
        setUserContactNumber("");
      } else {
        setError(result.error || "Failed to send email. Please try again.");
      }
    } catch (error) {
      setError("An error occurred while sending the email. Please try again.");
      console.error("Error sending email:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="ksm:px-12 kmd:px-20 kxl:px-32 ksm:py-3 kmd:py-5 kxl:py-8 ksm:text-[15px] kmd:text-30 klg:text-[48px] kxl:text-60 bg-[#005DA5] rounded-full text-white border-gray-50 border-4"
        onClick={openHandler}
      >
        Contact Us for Details
      </button>

      <CustomModal closeIcon={false} open={open} onClose={closeHandler}>
        <div className="px-5 h-full flex justify-center gap-10 items-center flex-col text-center">
          <div className="w-full">
            <div className="mb-8">
              <h3 className="text-lg font-medium">
                Please Enter Your Contact Details We will Contact you
                Immediately
              </h3>
            </div>
            <form className="w-full" onSubmit={sendEmail}>
              <input
                type="email"
                name="user_email"
                value={userEmail}
                onChange={(e) => setUserEmail(e.target.value)}
                className="mb-8 shadow appearance-none border rounded w-full py-4 px-3 text-black leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Enter email address"
                required
              />
              <input
                type="text"
                name="user_contact_number"
                value={userContactNumber}
                onChange={(e) => setUserContactNumber(e.target.value)}
                className="mb-8 shadow appearance-none border rounded w-full py-4 px-3 text-black leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Enter Contact Number"
              />
              <div className="flex gap-x-8">
                <button
                  className="bg-indigo-500 hover:bg-indigo-700 text-white font-bold py-3 px-4 w-full rounded focus:outline-none focus:shadow-outline"
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading ? "Sending..." : "Send Interest"}
                </button>

                <button
                  className="bg-indigo-500 hover:bg-indigo-700 text-white font-bold py-3 px-4 w-full rounded focus:outline-none focus:shadow-outline"
                  type="button"
                  onClick={closeHandler}
                  disabled={isLoading}
                >
                  Close
                </button>
              </div>
            </form>

            {error && <AlertError message={error} />}
            {isSuccess && (
              <AlertSuccess message="Your message has been received. We will reach out to you shortly." />
            )}
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default ContactUsButton;
